module.exports = __webpack_public_path__ + "img/service-code.7589387.png";